import { Component } from '@angular/core';

@Component({
    selector: 'app-pesquisa-salarial-sh-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura-sh.component.html',
    styleUrls: ['./bloqueio-assinatura-sh.component.css']
})

export class PesquisaSalarialSHBloqueioAssinaturaComponent {
}
